<template>
	<div class="tournament">
		<SubHeader
			title="JDO Tournament Prize Winner"
			subtitle="JDOトーナメント入賞者"
		/>

		<div class="container">
			<ul class="nav nav-pills mb-3" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2026"> 2026年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2025"> 2025年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link active" href="javascript:void(0);"> 2024年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2023"> 2023年度 </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/jdo/tournament2022"> 2022年度 </a>
				</li>
			</ul>

			<div id="20250330_hiroshima" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.03.30 第16回 広島ダーツ オープントーナメント</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 3位タイ</span>
							<img
								src="/images/jdo/2025//hiroshima/hiroshima_02.jpg"
								class="img-fluid"
							/>
							<span class="name">大達 浩司・稲井 亮輔</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2025//hiroshima/hiroshima_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025//hiroshima/hiroshima_03.jpg"
								class="img-fluid"
							/>
							<span class="name">北村 智加</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250126_kanagawa" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.03.23 第20回 ADO Darts Open Tournament</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025/aichi/aichi_01.jpg"
								class="img-fluid"
							/>
							<span class="name">北村 智加</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250126_kanagawa" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.02.25 第19回 京都ダーツ オープントーナメント2025</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 準優勝</span>
							<img
								src="/images/jdo/2025/kyoto/kyoto_01.jpg"
								class="img-fluid"
							/>
							<span class="name">石森 英彦・有田 真陶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 3位タイ</span>
							<img
								src="/images/jdo/2025/kyoto/kyoto_02.jpg"
								class="img-fluid"
							/>
							<span class="name">大達 浩司・礒和 勇希</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 3位タイ</span>
							<img
								src="/images/jdo/2025/kyoto/kyoto_03.jpg"
								class="img-fluid"
							/>
							<span class="name">礒和 勇希</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20250126_kanagawa" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2025.01.26 第24回 AKDO OPEN DARTS TOURNAMENT</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">レディースシングルス 準優勝</span>
							<img
								src="/images/jdo/2025/kanagawa/kanagawa_01.jpg"
								class="img-fluid"
							/>
							<span class="name">北村 智加</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20241124_nagano" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.11.24 NAGANO DARTS OPEN TOURNAMENT 2024</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">メンズシングルス 3位タイ</span>
							<img
								src="/images/jdo/2024/nagano/nagano_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20241012_interleague" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.10.12 JDO INTERLEAGUE CHAMPIONSHIP 2024</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">優勝</span>
							<img
								src="/images/jdo/2024/interleague/just01.jpg"
								class="img-fluid"
							/>
							<span class="name"
								>JUST<br />（角家 元二、松本 康寿、倉戸 亮、田原 駿也、西本
								陽一、石井 庸介、Paul Winterburn、浅田 斉吾、山下 竜起）</span
							>
						</p>
					</div>
				</div>
			</div>

			<div id="20240922_okayama" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.9.22 OKAYAMA OPEN DARTS TOURNAMENT 2024</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 優勝</span>
							<img
								src="/images/jdo/2024/okayama/okayama_01.jpg"
								class="img-fluid"
							/>
							<span class="name">青木 まゆ</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 3位タイ</span>
							<img
								src="/images/jdo/2024/okayama/okayama_02.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶・大本 直樹</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2024/kochi/kochi_01.jpg"
								class="img-fluid"
							/>
							<span class="name">北村 智加</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20240916_atokyo" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.9.16 ATDO DARTS TOURNAMENT 2024</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">オープンダブルス 3位タイ</span>
							<img
								src="/images/jdo/2024/atokyo/atokyo_01.jpg"
								class="img-fluid"
							/>
							<span class="name">小林 千尋・柳瀬 将一</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 3位タイ</span>
							<img
								src="/images/jdo/2024/atokyo/atokyo_02.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20240915_masters" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.9.15 JDO MASTER'S 2024</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">メンズ G1 準優勝</span>
							<img
								src="/images/jdo/2024/masters/masters_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディース G1 準優勝</span>
							<img
								src="/images/jdo/2024/masters/masters_02.jpg"
								class="img-fluid"
							/>
							<span class="name">青木 まゆ</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20240825_hyogo" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.8.25 第33回 H.D.O.オープンダーツトーナメント大会</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2024/hyogo/hyogo_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 準優勝</span>
							<img
								src="/images/jdo/2024/hyogo/hyogo_02.jpg"
								class="img-fluid"
							/>
							<span class="name">黒川 智成・外筬 久人</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">オープンダブルス 3位タイ</span>
							<img
								src="/images/jdo/2024/hyogo/hyogo_03.jpg"
								class="img-fluid"
							/>
							<span class="name">谷田 孝夫・高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20240714_ehime" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.7.14 OPEN DARTS TOUNAMENT IN EHIME 2024R6</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">オープンダブルス 優勝</span>
							<img
								src="/images/jdo/2024/07ehime/ehime_02.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶・大本 直樹</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 優勝</span>
							<img
								src="/images/jdo/2024/07ehime/ehime_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20240512_nara" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.6.30 SADO DARTS TOURNAMENT 2024</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">オープンダブルス 3位タイ</span>
							<img
								src="/images/jdo/2024/saitama/saitama_02.jpg"
								class="img-fluid"
							/>
							<span class="name">大達 浩司・高山 得溶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">メンズシングルス 3位タイ</span>
							<img
								src="/images/jdo/2024/saitama/saitama_01.jpg"
								class="img-fluid"
							/>
							<span class="name">高山 得溶</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20240512_nara" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.5.12 第4回 奈良ダーツオープントーナメント 2024</h4>
				</div>
				<div class="row mb-4">
					<div class="col-lg-4 text-center offset-lg-2">
						<p>
							<span class="rank">オープンダブルス 準優勝</span>
							<img src="/images/jdo/2024/nara/nara_01.jpg" class="img-fluid" />
							<span class="name">谷田 孝夫・高山 得溶</span>
						</p>
					</div>
					<div class="col-lg-4 text-center">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img src="/images/jdo/2024/nara/nara_02.jpg" class="img-fluid" />
							<span class="name">北村 智加</span>
						</p>
					</div>
				</div>
			</div>

			<div id="20231112_kanagawa" class="row d-flex align-items-end mb-4">
				<div class="col-12">
					<h4>2024.04.21 KOCHI OPEN DARTS TOURNAMENT vol.14</h4>
				</div>
				<div class="col-12 mb-4 row">
					<div class="col-lg-5 text-center mx-auto">
						<p>
							<span class="rank">レディースシングルス 3位タイ</span>
							<img
								src="/images/jdo/2024/kochi/kochi_01.jpg"
								class="img-fluid"
							/>
							<span class="name">北村 智加</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import SubHeader from "@/components/common/SubHeader.vue";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	name: "tournament2020",
	components: {
		SubHeader,
	},
	data() {
		return {};
	},
	mounted: function () {},
	methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 {
	font-size: 1.6rem;
	margin-bottom: 1rem;
}
h4 {
	border-bottom: solid 3px #333;
	padding-bottom: 5px;
	margin-bottom: 2rem;
	position: relative;
	&:before {
		content: "";
		width: 3rem;
		height: 3px;
		background-color: $primary-color;
		display: block;
		position: absolute;
		left: 0;
		bottom: -3px;
	}
}
a {
	text-decoration: underline;
}
.container {
	padding: 4rem 1rem;
	text-align: left;
}
.btn-download {
	font-size: 1rem;
	color: #333;
	border: none;
	margin-top: 1rem;
	background: $primary-color;
	text-decoration: none;
	cursor: pointer;
	&:hover {
		color: #333;
		background-color: $secondary-color;
	}
	&:active {
		color: #333;
		background-color: $secondary-color;
	}
}
.rank,
.rank_winner,
.rank_2nd,
.rank_3rd,
.name {
	color: #333;
}
.rank_winner {
	font-size: 2rem;
	i {
		color: #dbb400;
	}
}
.rank_2nd {
	font-size: 1.4rem;
	i {
		color: #9fa0a0;
	}
}
.rank_3rd {
	font-size: 1.4rem;
	i {
		color: #c47022;
	}
}
i {
	margin-right: 0.6rem;
}
</style>
